import {Routes} from '@angular/router';
import {loginComponent} from './views/login/login.component';
import {EnterByTokenComponent} from './views/enter-by-token/enter.by.token.component';
import {ForgotPasswordComponent} from './views/forgot-password/forgot-password.component';
import {SetPasswordComponent} from './views/set-password/set-password.component';
import {blankComponent} from "./components/common/layouts/blank.component";
import {basicComponent} from "./components/common/layouts/basic.component";
import {notFoundComponent} from "./components/common/layouts/not-found.component";
import {DashboardComponent} from "./views/dashboard/dashboard.component";
import {AdminsListComponent} from "./views/admins/admins-list.component";
import {ProfileViewComponent} from "./views/profile/profile-view.component";
import {UsersListComponent} from "./views/users/users-list.component";
import {UsersOneComponent} from "./views/users/user-one/user-one.component";
import {AuthGuard} from "./guards/auth.guard";
import {RoleComponent} from "./views/role/role.component";

import {routes as LeadsRoutes} from "./views/leads/leads.routes";
import {FilePreviewComponent} from "./views/file-preview/file-preview.component";
import {StatementsComponent} from "./modules/statements/statements.component";


export const ROUTES:Routes = [
    // App views
    {
        path: '', component: basicComponent,
        children: [
            { path: '', component: DashboardComponent, canActivate: [AuthGuard], },

            ...LeadsRoutes,

            //{ path: 'admins', component: AdminsListComponent, canActivate: [AuthGuard],  data: {permissions: ['dashboards.admins.view'] }, },
            { path: 'profile', component: ProfileViewComponent, canActivate: [AuthGuard] },

            {
                path: 'funding-specialist',
                canActivate: [AuthGuard],
                data: {permissions: ['dashboards.fs.view'] },
                loadChildren: 'app/views/funding-specialist/funding-specialist.module#FundingSpecialistModule'
            },

            {
                path: 'data-entry',
                canActivate: [AuthGuard],
                data: {permissions: ['dashboards.dataEntry.view'] },
                loadChildren: 'app/views/data-entry/data-entry.module#DataEntryModule'
            },

            {
                path: 'underwriter',
                canActivate: [AuthGuard],
                data: {permissions: ['dashboards.underwriter.view'] },
                loadChildren: 'app/views/underwriter/underwriter.module#UnderwriterModule'
            },

            {
                path: 'calculator-settings',
                canActivate: [AuthGuard],
                data: {permissions: ['calculatorSettings.allow'] },
                loadChildren: 'app/views/calculator-settings-main/calculator-settings-main.module#CalculatorSettingsMainModule'
            },

            {
                path: 'accounting',
                canActivate: [AuthGuard],
                data: {permissions: ['dashboards.accounting.view'] },
                loadChildren: 'app/views/accounting/accounting.module#AccountingModule'
            },

            { path: 'users', component: UsersListComponent, canActivate: [AuthGuard],  data: {permissions: ['dashboards.users.view'] }, },
            { path: 'users/:id', component: UsersOneComponent, canActivate: [AuthGuard],  data: {permissions: ['dashboards.users.view'] }, },
            { path: 'users/create', component: UsersOneComponent, canActivate: [AuthGuard],  data: {permissions: ['dashboards.users.view'] }, },

            { path: 'files/preview', component: FilePreviewComponent },


            {
                path: 'role',
                canActivate: [AuthGuard],
                data: {permissions: ['permissionsByRole.manipulation'] },
                component: RoleComponent
            },

            {
                path: 'crm-settings',
                canActivate: [AuthGuard],
                data: {permissions: ['crmSettings.allow'] },
                loadChildren: 'app/views/crm-settings/crm-settings.module#CRMSettingsModule'
            },
        ]
    },

    {
        path: 'statements/:debt_id',
        canActivate: [AuthGuard],
        data: {permissions: ['dashboards.accounting.view'] },
        component: StatementsComponent
    },

    {
        path: '', component: blankComponent,
        children: [
            { path: 'login', component: loginComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'set-password/:token', component: SetPasswordComponent },
            { path: 'enter/by/:token', component: EnterByTokenComponent }
        ]
    },

    // Handle all other routes
    {path: '**', component: notFoundComponent }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts